import { getCSSFromStyleObject, getStyleObjectFromCSS } from '@lexical/selection';
import { LexicalNode, TextNode } from 'lexical';
import * as Models from 'models';
import { $applyBrandStyleForList } from './Plugins/CustomListPlugin/brandStyle';
import { $applyBrandStyleForFont } from './Plugins/FontBrandStylePlugin/brandStyle';
import { $applyBrandStyleForTextBlock } from './Plugins/TextBlockPlugin/brandStyle';

export function $getTextNodeStyleValueForProperty(
  node: TextNode,
  styleProperty: string,
  defaultValue: string,
): string {
  const css = node.getStyle();
  const styleObject = getStyleObjectFromCSS(css);
  if (styleObject !== null) {
    return styleObject[styleProperty] || defaultValue;
  }

  return defaultValue;
}

export function $patchTextNodeStyle(
  node: TextNode,
  patch: Record<string, string | null>,
): void {
  const prevStyles = getStyleObjectFromCSS(node.getStyle());

  const newStyles = Object.entries(patch).reduce((styles, [key, value]) => {
    if (value === null) {
      delete styles[key];
    } else {
      styles[key] = value;
    }

    return styles;
  }, { ...prevStyles });

  node.setStyle(getCSSFromStyleObject(newStyles));
}

export function $applyBrandStyle(
  brandStyleToApply: Models.BrandStyleMap | undefined,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
): void {
  $applyBrandStyleForTextBlock(brandStyleToApply);
  $applyBrandStyleForFont(brandStyleToApply, colors, fonts);
  $applyBrandStyleForList(brandStyleToApply, colors);
}

export function $getAncestor<NodeType extends LexicalNode = LexicalNode>(
  node: LexicalNode,
  predicate: (ancestor: LexicalNode) => ancestor is NodeType,
): LexicalNode | null {
  let parent = node;
  while (parent !== null && parent.getParent() !== null && !predicate(parent)) {
    parent = parent.getParentOrThrow();
  }

  return predicate(parent) ? parent : null;
}
